<template>
  <v-btn
    class="mx-2"
    outlined
    small
    color="info"
    @click="$router.push(to || lastRoute)"
  >
    <v-icon dark small> mdi-arrow-left </v-icon>
    Back
  </v-btn>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "BackBtn",

  data() {
    return {};
  },
  props: {
    to: VueTypes.string,
  },
  computed: {
    lastRoute() {
      return this.$store.getters.getLastRoute;
    },
  },
});
</script>
